import React, { useEffect, useState } from 'react';
import { Skeleton, Avatar, Tooltip } from '@mui/material';
import moment from 'moment';
import { CommonDateOnlyFormat } from 'helpers/common.helper';

function SerialDetailsModal({ show, id, handleClose }) {
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({});
    const [serialDetails, setSerialDetails] = useState({});
    // const [customThumbnail, setCustomThumbnail] = useState('');
    const [defaultThumbnail, setDefaultThumbnail] = useState('');
    // const [repairLists, setRepairLists] = useState([]);
    useEffect(() => { 
        setIsVisible(show);
    }, [show]);


	const getSerialsDetails = () => {
		setIsLoading(true);
		api.getSerialsDetails(id).then((res) => {
			setIsLoading(false);
			setData(res.data?.stock);
			setDefaultThumbnail(res.data?.stock?.product?.custom_thumbnail_url);

			// res?.data?.stock?.product?.thumbnails?.map((thumbnail) => {
			// 	if (thumbnail?.is_default == 1) {
			// 		setDefaultThumbnail(thumbnail?.thumbnail_url);
			// 	}
			// });
			// setRepairLists(res.data?.repairs);
		});
	};

    useEffect(() => {
        getSerialsDetails();
    }, []);


    
    return (
        <>
            <div 
                className={`glass-effect-popup-overlay ${isVisible && 'show'}`}
                onClick={handleClose}
            >
                <div 
                    className={`glass-effect-popup-container md ${isVisible ? 'glassAnimateFadeIn' : 'glassAnimateFadeOut'}`}
                    style={{ display: isVisible ? 'block' : 'none' }}
                    onClick={e => e.stopPropagation()}
                >
                    {/* <button className="glass-effect-popup-close-icon">&times;</button> */}
                    <button className="btn modal-close-icon text-black" onClick={handleClose}>
                        <svg height="16" width="16" viewBox="0 0 19.295 19.289">
                            <path d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                        </svg>
                    </button>
                    
                    <div className="glass-effect-popup-content">
                        <div className="row">
                            <div className="col-12">
                                <div className="flex" style={{ gap: '15px', alignItems: 'center' }}>
                                    {
                                        isLoading ? (
                                            <div style={{ width: '98px', padding: '3px 0px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={'100px'} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <div>
                                                <img src={defaultThumbnail} style={{width: "60px", height: "100px"}}></img>
                                            </div>
                                            
                                        )
                                    }

                                    <div className="row">
                                        <div className="col-12 text-left fw-500" style={{ fontSize: '15px', marginBottom: '5px' }}>
                                            {
                                                isLoading ? (
                                                    <div style={{ width: '200px', padding: '3px 0px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    data?.product?.name
                                                )
                                            }
                                        </div>
                                        <div className="col-12 text-left" style={{ marginBottom: '5px' }}>
                                            {
                                                isLoading ? (
                                                    <div style={{ width: '150px', padding: '3px 0px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    <>
                                                        IMEI: {data?.imei || '---'}
                                                    </>
                                                    
                                                )
                                            }
                                            
                                        </div>
                                        <div className="col-12">
                                            <div style={{ width: "90px" }}>
                                            {
                                                isLoading ? (
                                                    <div style={{ width: '100%', padding: '3px 0px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    data?.status === 'inbound' ? (
                                                        <div className="badge badge-success" style={{ width: "100%" }}>Available</div>
                                                    ) : (
                                                        <div className="badge badge-secondary" style={{ width: "100%" }}>Not Available</div>
                                                    )
                                                    
                                                )
                                            }
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 fw-500" style={{ fontSize: '16px', margin: '20px auto 10px auto' }}>
                                Specification
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 font-14 text-gray-600">Product</div>
                            <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%', padding: '3px 0px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                        </div>
                                    ) : (
                                        data?.product?.name || '---'
                                    )
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 font-14 text-gray-600">SKU</div>
                            <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%', padding: '3px 0px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                        </div>
                                    ) : (
                                        data?.product?.sku || '---'
                                        
                                    )
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 font-14 text-gray-600">Category</div>
                            <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%', padding: '3px 0px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                        </div>
                                    ) : (
                                        data?.product?.category || '---'
                                        
                                    )
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 font-14 text-gray-600">Storage</div>
                            <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%', padding: '3px 0px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                        </div>
                                    ) : (
                                        data?.storage || '---'
                                        
                                    )
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 font-14 text-gray-600">Condition</div>
                            <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%', padding: '3px 0px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                        </div>
                                    ) : (
                                        data?.grade || '---'
                                        
                                    )
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 fw-500" style={{ fontSize: '16px', margin: '20px auto 10px auto' }}>
                                Order Information
                            </div>
                        </div>
                        {data?.transactions?.map((item, index) => (
                            <>
                                <div className="row">
                                    <div className="col-4 font-14 text-gray-600">Invoice</div>
                                    <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                        {
                                            isLoading ? (
                                                <div style={{ width: '100%', padding: '3px 0px' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                                </div>
                                            ) : (
                                                item?.invoice?.invoice_number
                                                
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 font-14 text-gray-600">Sales Order</div>
                                    <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                        {
                                            isLoading ? (
                                                <div style={{ width: '100%', padding: '3px 0px' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                                </div>
                                            ) : (
                                                item?.sales_order?.sales_order_number
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 font-14 text-gray-600">Customer</div>
                                    <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                        {
                                            isLoading ? (
                                                <div style={{ width: '100%', padding: '3px 0px' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                                </div>
                                            ) : (
                                                item?.customer?.name
                                                
                                            )
                                        }
                                    </div>
                                </div>
                            </>
                        ))}
                        <div className="row">
                            <div className="col-12 fw-500" style={{ fontSize: '16px', margin: '20px auto 10px auto' }}>
                                Fulfillment
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 font-14 text-gray-600">Inbound Date</div>
                            <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%', padding: '3px 0px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                        </div>
                                    ) : (
                                        data?.inbound_date ? moment(data?.inbound_date).format('dddd, DD MMM YYYY') : '---'
                                        
                                    )
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 font-14 text-gray-600">Shipped Date</div>
                            <div className="col-8 font-14" style={{ marginBottom: '3px' }}>
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%', padding: '3px 0px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
                                        </div>
                                    ) : (
                                        data?.transactions[0]?.shipped_date ? moment(data?.transactions[0]?.shipped_date).format('dddd, DD MMM YYYY') : '---'
                                        
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    {/* <div className="glass-effect-popup-actions">
                        <button className="btn btn-delete">Yes, Delete Shipment</button>
                        <button className="btn btn-cancel">Cancel</button>
                    </div> */}
                </div>
            </div>
			{/* <div className="glass-effect-popup-overlay show"></div> */}
        </>
    )
}
//     return (
//         <Modal
//             show={show}
//             onHide={handleClose}
//             centered
//             className="glass-effect-popup-container"
//             // size="md" -> Changed to md/sm for a better delete alert feel
//             size="md" 
//         >
//             <Modal.Body style={{ background: 'transparent', padding: '40px 30px' }}>
//                 {/* Close Icon */}
//                 <button className="btn glass-effect-popup-close-icon" onClick={handleClose}>
//                     <svg height="16" width="16" viewBox="0 0 19.295 19.289">
//                         <path d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
//                     </svg>
//                 </button>

//                 <div className="mb-3">
//                     <svg height="60px" width="60px" viewBox="0 0 267 267">
//                          <path d="M133.5 20l110 190H23.5L133.5 20z" fill="none" stroke="#e11d48" strokeWidth="15"/>
//                          <path d="M133.5 80v60" stroke="#e11d48" strokeWidth="15" strokeLinecap="round"/>
//                          <circle cx="133.5" cy="175" r="8" fill="#e11d48"/>
//                     </svg>
//                 </div>

//                 <h3 className="fw-bold">Confirm</h3>
//                 <p className="text-muted">Are you sure you want to delete this record? This action cannot be undone.</p>

//                 <div className="glass-effect-popup-actions mt-4">
//                     <button
//                         className="btn glass-effect-popup-btn-danger w-100"
//                         onClick={() => handleDelete(show.id)}
//                     >
//                         Delete
//                     </button>
//                     <button
//                         className="btn glass-effect-popup-btn-default w-100"
//                         onClick={handleClose}
//                     >
//                         Cancel
//                     </button>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );

export default SerialDetailsModal;